// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
h1 {
  margin: 30px 0;
}

.apple-certificate-info {
  margin: 0 16.66%;
}
.apple-certificate-info .row, .apple-certificate-info .form-group {
  margin-left: 0px;
  margin-right: 0px;
}
.apple-certificate-info h2 {
  margin: 30px 0 20px;
}
.apple-certificate-info .error-msg {
  color: hsl(0, 66%, 49%);
  padding-top: 5px;
  font: 1.4rem "Omnes-ATT-W02-Medium";
}
.apple-certificate-info .error-msg i {
  color: hsl(0, 66%, 49%);
}
.apple-certificate-info .error-msg .icon-badgealert {
  font-size: 12px;
}
.apple-certificate-info .message {
  font-size: 14px;
}
.apple-certificate-info .csr-link {
  padding-bottom: 30px;
}
.apple-certificate-info .ico {
  color: #fcbb15;
  font-size: 25px;
  margin-right: 10px;
}
.apple-certificate-info .applecertificate-status span {
  font: 1.6rem "Omnes-ATT-W02-Medium";
}
.apple-certificate-info .btn-secondary {
  background: linear-gradient(to bottom, #087ac2 0%, hsl(204.9, 94.4%, 35.1%) 100%);
}
.apple-certificate-info .btn-secondary:disabled {
  background: #d2d2d2;
}
.apple-certificate-info .apple-id {
  padding-left: 0;
}
.apple-certificate-info hr {
  margin: 0 -20px;
  opacity: 0.3;
}
.apple-certificate-info .appleid-section {
  border-top: 1px solid #d2d2d2;
}
.apple-certificate-info .appleid-section h3 {
  padding-top: 20px;
}
.apple-certificate-info .appleid-section p {
  padding-top: 20px;
}
.apple-certificate-info .appleid-field {
  padding-bottom: 30px;
}
.apple-certificate-info .cancel-button {
  padding: 30px 0 60px;
}
.apple-certificate-info .btn-link {
  padding-top: 10px;
}
.apple-certificate-info .status-list {
  margin: 10px 0;
}
.apple-certificate-info .status-list .label-block {
  display: inline-block;
  font: 1.4rem "Omnes-ATT-W02-Medium";
  width: 130px;
}
.apple-certificate-info .status-list span {
  padding-left: 15px;
}
.apple-certificate-info input:disabled {
  background-color: #d2d2d2;
  cursor: not-allowed;
}
.apple-certificate-info .apple-content {
  font-size: 14px;
  padding-left: 20px;
}
.apple-certificate-info ul {
  padding-left: 20px;
}
.apple-certificate-info ul li {
  list-style-type: disc;
  padding-bottom: 20px;
}
.apple-certificate-info .error {
  color: hsl(0, 66%, 49%);
  font-size: 14px;
  padding: 2px;
}
.apple-certificate-info .Expired {
  color: hsl(0, 66%, 49%);
}
.apple-certificate-info .nearingExpiration {
  color: hsl(0, 66%, 49%);
}

@media (max-width: 1024px) {
  .apple-certificate-info {
    margin: 0 20px auto;
  }
  .apple-certificate-info .btn-cancel {
    margin: 20px 0;
    text-align: center;
    width: 100%;
  }
  .apple-certificate-info .btn {
    text-align: center;
    width: 100%;
  }
  .apple-certificate-info .status-list {
    margin: 10px 0;
  }
  .apple-certificate-info .status-list .label-block {
    display: inline-block;
    font: 1.4rem "Omnes-ATT-W02-Medium";
    width: 300px;
  }
  .apple-certificate-info .status-list span {
    padding-left: 0;
  }
  .apple-certificate-info .appleid-field {
    padding-bottom: 20px;
  }
  .apple-certificate-info .cancel-button {
    padding: 20px 0 30px;
  }
  .apple-certificate-info .btn-cancel {
    margin: 20px 0 0;
  }
  .apple-certificate-info .btn-link {
    padding-top: 0;
  }
  .apple-certificate-info .btn {
    padding: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/apple-certificate/info/apple-certificate-info.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACE,cAAA;AAmJF;;AAhJA;EACE,gBAAA;AAmJF;AAjJE;EACE,gBAAA;EACA,iBAAA;AAmJJ;AAhJE;EACE,mBAAA;AAkJJ;AA/IE;EACE,uBAAA;EACA,gBAAA;EACA,mCAAA;AAiJJ;AAhJI;EACA,uBAAA;AAkJJ;AAhJI;EACE,eAAA;AAkJN;AA9IE;EACE,eAAA;AAgJJ;AA9IE;EACE,oBAAA;AAgJJ;AA7IE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AA+IJ;AA3II;EACE,mCAAA;AA6IN;AAzIE;EACE,iFAAA;AA2IJ;AAzII;EACA,mBAAA;AA2IJ;AAvIE;EACE,eAAA;AAyIJ;AAtIE;EACE,eAAA;EACA,YAAA;AAwIJ;AAtIE;EACE,6BAAA;AAwIJ;AAvII;EACE,iBAAA;AAyIN;AAvII;EACE,iBAAA;AAyIN;AAtIE;EACE,oBAAA;AAwIJ;AAtIE;EACE,oBAAA;AAwIJ;AArIE;EACE,iBAAA;AAuIJ;AApIE;EACE,cAAA;AAsIJ;AApII;EACE,qBAAA;EACA,mCAAA;EACA,YAAA;AAsIN;AAnII;EACE,kBAAA;AAqIN;AAhIE;EACE,yBAAA;EACA,mBAAA;AAkIJ;AA/HE;EACE,eAAA;EACA,kBAAA;AAiIJ;AA/HE;EACE,kBAAA;AAiIJ;AAhIG;EACG,qBAAA;EACA,oBAAA;AAkIN;AA/HE;EACE,uBAAA;EACA,eAAA;EACA,YAAA;AAiIJ;AA9HG;EACE,uBAAA;AAgIL;AA9HG;EACC,uBAAA;AAgIJ;;AFtOI;EE4GJ;IACE,mBAAA;EA8HA;EA5HA;IACE,cAAA;IACA,kBAAA;IACA,WAAA;EA8HF;EA3HA;IACE,kBAAA;IACA,WAAA;EA6HF;EA1HA;IACE,cAAA;EA4HF;EA1HE;IACE,qBAAA;IACA,mCAAA;IACA,YAAA;EA4HJ;EAzHE;IACE,eAAA;EA2HJ;EAxHA;IACI,oBAAA;EA0HJ;EAvHE;IACE,oBAAA;EAyHJ;EAtHI;IACE,gBAAA;EAwHN;EArHI;IACE,cAAA;EAuHN;EApHI;IACE,UAAA;EAsHN;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\nh1 {\n  margin: 30px 0;\n}\n\n.apple-certificate-info {\n  margin: 0 16.66%;\n\n  .row, .form-group {\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n\n  h2  {\n    margin: 30px 0 20px;\n  }\n\n  .error-msg {\n    color: color(danger, base);\n    padding-top: 5px;\n    font: 1.4rem 'Omnes-ATT-W02-Medium';\n    i {\n    color: color(danger, base);\n    }\n    .icon-badgealert {\n      font-size: 12px;\n    }\n  }\n\n  .message {\n    font-size: 14px;\n  }\n  .csr-link {\n    padding-bottom: 30px;\n  }\n\n  .ico {\n    color: color(appleNotinstalled);\n    font-size: 25px;\n    margin-right: 10px;\n  }\n\n  .applecertificate-status {\n    span {\n      font: 1.6rem 'Omnes-ATT-W02-Medium';\n    }\n  }\n\n  .btn-secondary {\n    background: linear-gradient(to bottom, #087ac2 0%, color(secondary,base) 100%);\n  \n    &:disabled {\n    background: color(default,dark);\n    }\n  }\n\n  .apple-id {\n    padding-left: 0;\n  }\n\n  hr {\n    margin: 0 -20px;\n    opacity: .3;\n  }\n  .appleid-section{\n    border-top: 1px solid color(default, dark);\n    h3{\n      padding-top: 20px;\n    }\n    p{\n      padding-top: 20px;\n    }\n  }\n  .appleid-field{\n    padding-bottom: 30px\n  }\n  .cancel-button{\n    padding: 30px 0 60px;\n  }\n\n  .btn-link {\n    padding-top: 10px;\n  }\n  \n  .status-list {\n    margin: 10px 0;\n\n    .label-block {\n      display: inline-block;\n      font: 1.4rem 'Omnes-ATT-W02-Medium';\n      width: 130px;\n    }\n\n    span {\n      padding-left: 15px;\n    }\n\n  }\n\n  input:disabled{\n    background-color:#d2d2d2;\n    cursor: not-allowed;\n  }\n\n  .apple-content {\n    font-size: 14px;\n    padding-left: 20px;\n  }\n  ul{\n    padding-left: 20px;\n   li{\n      list-style-type : disc;\n      padding-bottom: 20px;\n    } \n   }\n  .error {\n    color: color(danger, base);\n    font-size: 14px;\n    padding: 2px;\n    }\n\n   .Expired {\n     color: color(danger, base);\n   }\n   .nearingExpiration{\n    color: color(danger, base);\n   }\n}\n\n@include respond-to(small) {\n\n.apple-certificate-info {\n  margin: 0 20px auto;\n\n  .btn-cancel {\n    margin: 20px 0;\n    text-align: center;\n    width: 100%;\n   }\n\n  .btn {\n    text-align: center;\n    width: 100%;\n    }\n\n  .status-list {\n    margin: 10px 0;\n\n    .label-block {\n      display: inline-block;\n      font: 1.4rem 'Omnes-ATT-W02-Medium';\n      width: 300px;\n    }\n\n    span {\n      padding-left: 0;\n    }\n  }\n  .appleid-field {\n      padding-bottom: 20px;\n      }     \n    \n    .cancel-button {\n      padding: 20px 0 30px;\n      }\n\n      .btn-cancel {\n        margin: 20px 0 0;\n      }\n\n      .btn-link {\n        padding-top: 0;\n      }\n\n      .btn {\n        padding: 0;\n      }\n}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
